import { render, staticRenderFns } from "./MaterialCoverage.vue?vue&type=template&id=dd8e094e"
import script from "./MaterialCoverage.vue?vue&type=script&lang=js"
export * from "./MaterialCoverage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports